import View from '@/views/PointMirror/View'
import My from '@/views/PointMirror/My'
import Manager from '@/views/PointMirror/Manager'
import Consult from '@/views/PointMirror/Consult'

const routes = {
  path: '/point-mirror',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/point-mirror/view',
      name: 'Espelho de ponto',
      component: View,
    },
    {
      path: '/point-mirror-consult',
      name: 'consult-point-mirror',
      component: Consult,
    },
    {
      path: '/point-mirror/my',
      name: 'Meus espelhos de ponto',
      component: My,
    },
    {
      path: '/point-mirror/:month?/:year?',
      name: 'close-point-mirror',
      component: Manager,
    },
  ],
}

export default routes
